module.exports = new __parcel__URL__("dotlake-transparent-high-quality.04cb8c2b.png").toString();